<div class="forgot-password">
  <div class="div">
    <div class="card">
      <div class="frame" *ngIf="!isSubmitted">
        <div class="frame-2">
          <div class="frame-3">
            <div class="text-wrapper-3">Forgot password?</div>
            <p class="no-worries-just-en">
              No worries! Just enter your email and we’ll send you a reset
              password link.
            </p>
          </div>
          <input
            type="email"
            class="email-address-wrapper"
            [formControl]="emailFormControl"
            (input)="onInputChange()"
          />
          <div
            class="error-message"
            *ngIf="isEmailSubmitted && emailFormControl.hasError('required')"
          >
            Email is required.
          </div>
          <div
            class="error-message"
            *ngIf="isEmailSubmitted && emailFormControl.hasError('email')"
          >
            Please enter a valid email format.
          </div>
        </div>
        <button (click)="validateSend()" class="button">
          Send Recovery Email
        </button>
      </div>
      <check-email
        *ngIf="isSubmitted"
        (childEvent)="updateIsClicked($event)"
      ></check-email>
    </div>
    <img class="image" alt="Image" src="../../../assets/image.svg" />
  </div>
</div>
